import { useApi } from '@/api';
import { ChartSkeleton } from '@/components';
import { useChartTooltip } from '@/hooks';
import { Flex, formatPercentage, DoughnutChart } from '@blockanalitica/ui';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ILKS_PALETTE } from '@/constants'; // Assuming this is the correct path

export default function IlkCompositionDonutChart() {
  const [data, error] = useApi({
    url: '/at-risk/share/ilks/'
  });

  if (error) {
    throw error;
  }

  const navigate = useNavigate();
  const customTooltip = useChartTooltip(
    data,
    'ilk',
    'share',
    true,
    'debt_at_risk'
  );

  const chartData = useMemo(() => {
    if (data) {
      return {
        labels: data.map((row) => row.ilk),
        datasets: [
          {
            data: data.map((row) => row.share),
            backgroundColor: data.map((row) => ILKS_PALETTE[row.ilk]),
            borderColor: data.map((row) => ILKS_PALETTE[row.ilk]),
            hoverOffset: 30
          }
        ]
      };
    }
    return null;
  }, [data]);

  const mapping = useMemo(() => {
    if (data) {
      return data.reduce((acc, row) => {
        const key = row.ilk;
        acc[key] = key === 'others' ? `core` : `core/${row.ilk}`;
        return acc;
      }, {});
    }
    return {};
  }, [data]);

  const customConfig = useMemo(
    () => ({
      options: {
        aspectRatio: 1.8,
        layout: {
          padding: 10
        },
        plugins: {
          legend: {
            position: 'bottom'
          },
          tooltip: {
            enabled: false,
            position: 'nearest',
            external: customTooltip
          }
        }
      }
    }),
    [customTooltip]
  );

  if (data) {
    return (
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        paddingTop="m"
        width="100%">
        <DoughnutChart
          // @ts-ignore
          config={customConfig}
          data={chartData}
          valueFormatter={formatPercentage}
          url={`/collateral`}
          navigate={navigate}
          mapping={mapping}
        />
      </Flex>
    );
  }

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      paddingTop="m"
      width="100%"
      height="100%">
      <ChartSkeleton type="doughnut" />
    </Flex>
  );
}
